module.exports = __webpack_public_path__ + "static/media/c5bannerModul3_small.13cf3696.jpg";